export const handelChangeMainSite = (main) => ({
    type: 'CHANGE_BASE_MAIN_SITE',main
});

export const handleChangeDataMainSite = (name,value) => ({
    type: 'CHANGE_DATA_MAIN_SITE',name,value
});